import { RefObject, useEffect, useState } from "react";
import _ from "lodash";

export const useClickOutside = (
    containerRef: RefObject<HTMLDivElement> | null,
    callback: () => void,
    expectClasses: string[] = [],
) => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            let isExpectElement = false;
            for (const expectClass of expectClasses) {
                if ((event.target as HTMLElement).classList.contains(expectClass)) {
                    isExpectElement = true;
                    break;
                }
            }
            if (
                containerRef &&
                containerRef.current &&
                !containerRef.current.contains(event.target as Node) &&
                !isExpectElement
            ) {
                callback();
            }
        };

        window.addEventListener("mousedown", handleClickOutside);
        return () => window.removeEventListener("mousedown", handleClickOutside);
    }, [containerRef, callback]);
};

export function useScrollPosition(pageRef: { current: any }) {
    const [scrollPosition, setScrollPosition] = useState<number>(pageRef.current?.scrollTop);
    const handleScroll = () => {
        if (__BROWSER__) {
            const position = pageRef.current.scrollTop;
            setScrollPosition(position);
        }
    };

    useEffect(() => {
        if (__BROWSER__) {
            pageRef.current.addEventListener("scroll", handleScroll, { passive: false });
            return () => {
                pageRef.current ? pageRef.current.removeEventListener("scroll", handleScroll) : undefined;
            };
        }
    }, []);

    return scrollPosition;
}

export function useWindowSize(throttle?: number) {
    const [windowSize, setWindowSize] = useState({ width: -1, height: -1 });
    useEffect(() => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
        const listener = _.throttle(
            () =>
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                }),
            throttle ?? 100,
        );
        window.addEventListener("resize", listener);
        return () => window.removeEventListener("resize", listener);
    }, []);
    return windowSize;
}
